<script lang="ts" setup>
import {
  GetProfileStudyDocument,
  GetStudyDocument,
  type Study,
} from '~/utils/generated/graphql'
import NextButton from '~/components/study/NextButton.vue'
import { getItemImageUrl } from '~/utils/graphql/graphql'
import { useGraphQuery } from '~/utils/graphql/client'

const user = useFirebaseUser()
const route = useRoute()
const { locale } = useI18n()

const { data, error, refresh } = await useGraphQuery(GetStudyDocument, { slug: route.params.slug, session: route.params.sessionslug, locale: locale })
const study = computed(() => data.value?.contentItem as Study | null | undefined)
const studyId = computed(() => study.value?.id)
const { data: profile, refresh: profileRefresh } = await useGraphQuery(GetProfileStudyDocument, { studyId: studyId }, true, false)
const pageTitle = computed(() => study.value?.session?.title + ' - ' + study.value?.title)
const pageDescription = computed(() => study.value?.session?.description || '')
const sessionIdSuffix = '-' + route.params.sessionslug

useHead({
  title: pageTitle,
})

watch(user, () => {
  if (user.value) {
    profileRefresh()
  }
})

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
  ogImage: computed(() => getItemImageUrl(study.value)),
  ogUrl: 'https://passionequip.com/studies/' + route.params.slug + '/' + route.params.sessionslug,
})

onMounted(() => {
  if (user.value) {
    profileRefresh()
  }
})
</script>

<template>
  <PageContent
    v-if="study"
    disable-top-padding
  >
    <ContentItemHeader :item="study" />
    <a id="nav" />
    <div class="prose dark:prose-invert ps-4 pt-3 pe-4 m-auto">
      <div class="md:ms-16 md:me-16">
        <StudyNavigation
          :study="study"
          :profile="profile?.profile.study"
        />
        <StudySessionContent
          :study="study"
          :index="study.sessions.findIndex((s) => s.id.endsWith(sessionIdSuffix))"
          class="prose-xl px-4 lg:basis-3/5"
        />
        <NextButton
          :study="study"
          :profile="profile?.profile.study"
        />
        <hr>
        <ContentAuthor :item="study" />
      </div>
    </div>
  </PageContent>
  <ContentError
    v-else-if="error"
    :refresh="refresh"
  />
</template>
